var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("h2", [_vm._v("Refine Search")]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "link back", attrs: { href: _vm.getBackToSearch() } },
        [_vm._v("Back to Full Search")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "form-group col-lg-4 col-md-6 col-xs-12" }, [
          _c("label", { attrs: { for: "make" } }, [_vm._v("Make")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.make,
                  expression: "data.make"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "make", name: _vm.getNameField("make") },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.data,
                    "make",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "" } }, [_vm._v("All")]),
              _vm._v(" "),
              _vm._l(_vm.makes, function(make) {
                return _c("option", { domProps: { value: make.name } }, [
                  _vm._v(_vm._s(make.name) + " (" + _vm._s(make.count) + ")")
                ])
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group col-lg-4 col-md-6 col-xs-12" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "text",
                readonly: "",
                id: "model",
                name: _vm.getNameField("model", _vm.selectedModels),
                placeholder: "Model"
              },
              domProps: { value: _vm.objectToString(_vm.selectedModels) },
              on: {
                click: function($event) {
                  _vm.showModelModal = true
                }
              }
            }),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "ModalModel",
                attrs: {
                  size: "lg",
                  id: "modal-model",
                  "hide-footer": "",
                  title: _vm.data.make
                },
                on: { hidden: _vm.onHideModelModal },
                model: {
                  value: _vm.showModelModal,
                  callback: function($$v) {
                    _vm.showModelModal = $$v
                  },
                  expression: "showModelModal"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "content-list-models" },
                  [
                    _c("div", { staticClass: "form-group inline-label" }, [
                      _c("label", { attrs: { for: "models-in-modal" } }, [
                        _vm._v("Models")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "text",
                          readonly: "",
                          id: "models-in-modal",
                          placeholder: "Models"
                        },
                        domProps: {
                          value: _vm.objectToString(_vm.selectedModels)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "link",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.selectedModels = {}
                            }
                          }
                        },
                        [_vm._v("Clear")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.showModelModal = false
                            }
                          }
                        },
                        [_vm._v("Done")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.model_list, function(vehiclemodel) {
                      return _c("div", { staticClass: "list-of-models" }, [
                        _c("span", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedModels[vehiclemodel.name],
                                expression: "selectedModels[vehiclemodel.name]"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "make-" + vehiclemodel.name
                            },
                            domProps: {
                              value: vehiclemodel.name,
                              checked: Array.isArray(
                                _vm.selectedModels[vehiclemodel.name]
                              )
                                ? _vm._i(
                                    _vm.selectedModels[vehiclemodel.name],
                                    vehiclemodel.name
                                  ) > -1
                                : _vm.selectedModels[vehiclemodel.name]
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.selectedModels[vehiclemodel.name],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = vehiclemodel.name,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.selectedModels,
                                        vehiclemodel.name,
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.selectedModels,
                                        vehiclemodel.name,
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.selectedModels,
                                    vehiclemodel.name,
                                    $$c
                                  )
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "make-" + vehiclemodel.name } },
                            [
                              _vm._v(
                                _vm._s(vehiclemodel.name) +
                                  " (" +
                                  _vm._s(vehiclemodel.count) +
                                  ")"
                              )
                            ]
                          )
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-group col-lg-4 col-md-6 col-xs-12" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-group col-md-5" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.exclude_year_min,
                      expression: "data.exclude_year_min"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "exclude_year_min", name: "exclude_year_min" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.data,
                        "exclude_year_min",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "", selected: "" } }, [
                    _vm._v("Min")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.years, function(year) {
                    return _c("option", { domProps: { value: year } }, [
                      _vm._v(_vm._s(year))
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-5" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.exclude_year_max,
                      expression: "data.exclude_year_max"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "exclude_year_max", name: "exclude_year_max" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.data,
                        "exclude_year_max",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "", selected: "" } }, [
                    _vm._v("Max")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.years, function(year) {
                    return _c("option", { domProps: { value: year } }, [
                      _vm._v(_vm._s(year))
                    ])
                  })
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "form-group col-lg-4 col-md-6 col-xs-12" }, [
          _c("label", { attrs: { for: "condition_min" } }, [
            _vm._v("Auction grade")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-group col-md-5" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.condition_min,
                      expression: "data.condition_min"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "condition_min",
                    name: _vm.getNameField("condition_min")
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.data,
                        "condition_min",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "", selected: "" } }, [
                    _vm._v("Min")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "0.0" } }, [_vm._v("0.0")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "2.0" } }, [_vm._v("2.0")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "3.0" } }, [_vm._v("3.0")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "3.5" } }, [_vm._v("3.5")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "4.0", selected: "TRUE" } }, [
                    _vm._v("4.0")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "4.5" } }, [_vm._v("4.5")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "5.0" } }, [_vm._v("5.0")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "9.0" } }, [_vm._v("9.0")])
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-5" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.condition_max,
                      expression: "data.condition_max"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "condition_max",
                    name: _vm.getNameField("condition_max")
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.data,
                        "condition_max",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "", selected: "" } }, [
                    _vm._v("Max")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "0.0" } }, [_vm._v("0.0")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "2.0" } }, [_vm._v("2.0")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "3.0" } }, [_vm._v("3.0")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "3.5" } }, [_vm._v("3.5")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "4.0" } }, [_vm._v("4.0")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "4.5" } }, [_vm._v("4.5")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "5.0" } }, [_vm._v("5.0")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "9.0" } }, [_vm._v("9.0")])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group col-lg-4 col-md-6 col-xs-12",
            attrs: { id: "mileage" }
          },
          [
            _c("label", { attrs: { for: "mileage_min" } }, [_vm._v("Mileage")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "form-group col-md-5" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.mileage_min_proxy,
                      expression: "mileage_min_proxy"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", id: "mileage_min" },
                  domProps: { value: _vm.mileage_min_proxy },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.mileage_min_proxy = $event.target.value
                    }
                  }
                }),
                _c("span", [_vm._v(",000")]),
                _vm._v(" "),
                _vm.data.mileage_min
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.mileage_min,
                          expression: "data.mileage_min"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "hidden",
                        name: _vm.getNameField("mileage_min")
                      },
                      domProps: { value: _vm.data.mileage_min },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.data, "mileage_min", $event.target.value)
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-md-5" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.mileage_max_proxy,
                      expression: "mileage_max_proxy"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", id: "mileage_max" },
                  domProps: { value: _vm.mileage_max_proxy },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.mileage_max_proxy = $event.target.value
                    }
                  }
                }),
                _c("span", [_vm._v(",000")]),
                _vm._v(" "),
                _vm.data.mileage_max
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.mileage_max,
                          expression: "data.mileage_max"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "hidden",
                        name: _vm.getNameField("mileage_max")
                      },
                      domProps: { value: _vm.data.mileage_max },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.data, "mileage_max", $event.target.value)
                        }
                      }
                    })
                  : _vm._e()
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-group col-lg-4 col-md-6 col-xs-12" }, [
          _vm._m(5),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.transmission,
                  expression: "data.transmission"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "transmission", name: "transmission" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.data,
                    "transmission",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "", selected: "" } }, [
                _vm._v("All")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "1" } }, [_vm._v("Manual")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2" } }, [_vm._v("Automatic")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "0" } }, [_vm._v("Unknown")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "col-lg-8 col-md-6 col-xs-12" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "content-checkbox col-md-12" }, [
              _c("div", { staticClass: "latest checkbox" }, [
                _vm.data.latest_listing
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.latest_listing,
                          expression: "data.latest_listing"
                        }
                      ],
                      staticClass: "latest",
                      attrs: {
                        type: "checkbox",
                        name: "latest_listing",
                        value: "latest",
                        id: "latest_listing",
                        checked: ""
                      },
                      domProps: {
                        checked: Array.isArray(_vm.data.latest_listing)
                          ? _vm._i(_vm.data.latest_listing, "latest") > -1
                          : _vm.data.latest_listing
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.data.latest_listing,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "latest",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.data,
                                  "latest_listing",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.data,
                                  "latest_listing",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.data, "latest_listing", $$c)
                          }
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.latest_listing,
                      expression: "data.latest_listing"
                    }
                  ],
                  staticClass: "latest",
                  attrs: {
                    type: "checkbox",
                    name: "latest_listing",
                    value: "latest",
                    id: "latest_listing",
                    else: ""
                  },
                  domProps: {
                    checked: Array.isArray(_vm.data.latest_listing)
                      ? _vm._i(_vm.data.latest_listing, "latest") > -1
                      : _vm.data.latest_listing
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.data.latest_listing,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "latest",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.data,
                              "latest_listing",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.data,
                              "latest_listing",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.data, "latest_listing", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "latest_listing" } }, [
                  _vm._v("Only Show latest listings")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exclude checkbox" }, [
                _vm.data.exclude_listing
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.exclude_listing,
                          expression: "data.exclude_listing"
                        }
                      ],
                      staticClass: "exclude",
                      attrs: {
                        type: "checkbox",
                        name: "exclude_listing",
                        value: "exclude",
                        id: "exclude_listing",
                        checked: ""
                      },
                      domProps: {
                        checked: Array.isArray(_vm.data.exclude_listing)
                          ? _vm._i(_vm.data.exclude_listing, "exclude") > -1
                          : _vm.data.exclude_listing
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.data.exclude_listing,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "exclude",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.data,
                                  "exclude_listing",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.data,
                                  "exclude_listing",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.data, "exclude_listing", $$c)
                          }
                        }
                      }
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.exclude_listing,
                          expression: "data.exclude_listing"
                        }
                      ],
                      staticClass: "exclude",
                      attrs: {
                        type: "checkbox",
                        name: "exclude_listing",
                        value: "exclude",
                        id: "exclude_listing"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.data.exclude_listing)
                          ? _vm._i(_vm.data.exclude_listing, "exclude") > -1
                          : _vm.data.exclude_listing
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.data.exclude_listing,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "exclude",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.data,
                                  "exclude_listing",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.data,
                                  "exclude_listing",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.data, "exclude_listing", $$c)
                          }
                        }
                      }
                    }),
                _vm._v(" "),
                _c("label", { attrs: { for: "exclude_listing" } }, [
                  _vm._v("Exclude already seen")
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 col-md-6 col-xs-12" }, [
          _c("div", { staticClass: "buttons" }, [
            _c("div", { staticClass: "container-buttons" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  attrs: { href: "#" },
                  on: { click: _vm.clearForm }
                },
                [_vm._v("Clear form")]
              ),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "btn btn-primary", attrs: { href: "#" } },
                [_vm._v("Save Search")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  attrs: { href: "#" },
                  on: { click: _vm.getSearchFormParameters }
                },
                [_vm._v("Search")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group inline-label" }, [
              _c("label", { attrs: { for: "saveSearch" } }, [
                _vm._v("Saved Search")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.saveSearch,
                    expression: "data.saveSearch"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "saveSearch",
                  id: "saveSearch",
                  placeholder: "Saved Search"
                },
                domProps: { value: _vm.data.saveSearch },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "saveSearch", $event.target.value)
                  }
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "ul",
            { staticClass: "advance-search-tag" },
            [
              _vm._l(_vm.dataAdvance, function(item, index) {
                return [
                  item
                    ? [
                        index == "excluded_makes" || index == "lot"
                          ? _c("li", [
                              item
                                ? _c(
                                    "span",
                                    { staticClass: "tag-name-group" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.searchTags(index)) + " "
                                      ),
                                      _vm._l(item.split(","), function(value) {
                                        return _c(
                                          "a",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.removeFieldsFromSearch(
                                                  index,
                                                  value
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(_vm._s(value) + " "),
                                            _c(
                                              "span",
                                              { staticClass: "remove-item" },
                                              [_vm._v("X")]
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          : _c("li", [
                              item
                                ? _c("span", { staticClass: "tag-name" }, [
                                    _vm._v(_vm._s(_vm.searchTags(index)) + " "),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFieldsFromSearch(
                                              index,
                                              item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(_vm._s(item) + " "),
                                        _c(
                                          "span",
                                          { staticClass: "remove-item" },
                                          [_vm._v("X")]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                      ]
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "model" } }, [
      _vm._v("Model"),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "exclude_year_min" } }, [
      _c("span", [_vm._v("Exclude Year")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group col-md-2 middle" }, [
      _c("span", [_vm._v("to")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group col-md-2 middle" }, [
      _c("span", [_vm._v("to")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group col-md-2 middle" }, [
      _c("span", [_vm._v("to")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "transmission" } }, [
      _vm._v("Transmission"),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h3", [_vm._v("Options")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c75efe0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c75efe0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/RefineSearch.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7c75efe0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/RefineSearch.vue
// module chunks = 0